module.exports = __webpack_public_path__ + "img/th.181b0fbf.svg";